import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DropdownDTO } from "../../../types/common/DropdownDTO";

interface ICountryState {
  countryDropdown: DropdownDTO[];
}

const initialState: ICountryState = {
  countryDropdown: []
};

export const countrySlice = createSlice({
  name: 'country',
  initialState,
  reducers: {
    loadingCountryDropdown: (state, action: PayloadAction<DropdownDTO[]>) => {
      state.countryDropdown = action.payload;
    },
  }
});

export const { loadingCountryDropdown } = countrySlice.actions;
export default countrySlice.reducer;
